module.exports = "/assets/data/45d38fb805ed584737e2e778a57ce30c-UB3.data.json";